// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-user-scene-wrapper {
  padding: 0.06rem 20rem 12rem;
}
.new-user-scene-wrapper .user-options {
  display: flex;
  gap: 4.9rem;
}
.new-user-scene-wrapper .user-options.horizontal {
  flex-direction: column;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/NewUserScene/index.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AACE;EACE,aAAA;EACA,WAAA;AACJ;AAAI;EACE,sBAAA;EACA,SAAA;AAEN","sourcesContent":[".new-user-scene-wrapper {\n  padding: 0.06rem 20rem 12rem;\n\n  .user-options {\n    display: flex;\n    gap: 4.9rem;\n    &.horizontal {\n      flex-direction: column;\n      gap: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
